import { App } from 'vue';
import PortalVue from 'portal-vue';
import { ModalManager } from './modal-manager';
import { ModalService } from './modal-service';
import ItpModalHost from './ItpModalHost.vue';

declare module 'vue' {
  interface ComponentCustomProperties {
    $imodal: ModalService;
  }
}

export function createModalPlugin() {
  const manager = new ModalManager();
  const service = new ModalService(manager);

  return {
    install(app: App) {
      app.use(PortalVue);
      manager.setApp(app);
      app.config.globalProperties.$imodal = service;
      app.component('ItpModalHost', ItpModalHost);
    },
    service,
  };
}
